/* eslint-disable no-undef */
import $ from "jquery";

const updateProduct = () => {
    const init = () => {
        submitForm();
    };

    const submitForm = () => {
        $(document).on("click", "#js_btn_save_product_data", function () {
            const form_data = $("#js_form_update_product").serialize();
            const maintenance_history = $("#maintenance-history_ifr").val();
            // console.log(maintenance_history);
            const back_url = $("#backurl").val();
            const parent = $(this).parent();
            const parentSelect = parent
                .siblings(".SingleInfoCarForm__Autogegevens")
                .find(".Additional__Input--additional-accessories");

            const classSelect = ".Additional__Input__Wrapper";
            const selectAcc = parentSelect
                .find("> .Additional__Input__Wrapper")
                .find('select[name="accessory[]"]');
            const selectOther = selectAcc.siblings(
                'input[name="other_accessory[]"]',
            );

            // check if user select anders but not fill field
            const errormessage = ".js-error-message_anders";
            $(errormessage).hide();

            if ($(classSelect).length > 0) {
                if (selectAcc.length > 0) {
                    if (selectOther.is(":visible") && selectOther.val() == "") {
                        $(errormessage).show();
                        return;
                    }
                }
            }
            $.ajax({
                type: "POST",
                url: themeObj.ajaxUrl,
                data: {
                    form_data: form_data,
                    maintenance_history: maintenance_history,
                    nonce: themeObj.products.nonce,
                    action: themeObj.products.action.update,
                },
            })
                .done(() => {
                    window.location.href = back_url;
                })
                .fail((response) => {
                    console.error(response);
                });
        });
    };

    init();
};

try {
    updateProduct();
} catch (error) {
    console.error("form: ", error);
}
